import { render, staticRenderFns } from "./PatientCredential.vue?vue&type=template&id=e7b748fa&scoped=true&lang=pug"
import script from "./PatientCredential.vue?vue&type=script&lang=js"
export * from "./PatientCredential.vue?vue&type=script&lang=js"
import style0 from "./PatientCredential.vue?vue&type=style&index=0&id=e7b748fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b748fa",
  null
  
)

export default component.exports